export default {
  contentInfoReserve:{
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    width: '100%',
    position: 'relative',
    boxSizing: 'border-box',
  },
  contentModuleRow: {
    display: 'flex',
  },
  contentModuleCell: {
    width: '50%',
  },
  short: {
    width: '35%'
  },
  large: {
    width: '65%',
    textAlign: 'right'
  },
  occupIcon: {
    position: 'relative',
    bottom: '1px',
    right: '2px',
  }
};

